<template>
  <!-- Report -->
  <div class="modal fade" id="report-reason">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Report Reason</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="block-user-blk">
            <p>
              Directing hate against a protected category (e.g., race, religion, gender,
              orientation, disability)
            </p>
          </div>
          <div class="mute-chat-btn">
            <a class="btn btn-primary" data-bs-dismiss="modal" :aria-label="$t('close')"> Ok </a>
            <a class="btn btn-secondary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Report -->

  <!-- Delete User -->
  <div class="modal fade" id="delete-user">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Delete User</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <div class="block-user-blk">
            <p>
              Clearing or deleting entire users will only remove messages from this device
            </p>
          </div>
          <div class="mute-chat-btn justify-content-center">
            <a class="btn btn-primary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Continue
            </a>
            <a class="btn btn-secondary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete User -->
</template>
